import { ColumnDef } from '@tanstack/react-table';
import { useState } from 'react';
import { Stack } from 'react-bootstrap';
import ConfirmationModal from '../../../components/modals/ConfirmationModal';
import { LinkCell } from '../../../components/tables/cellComponents/LinkCell';
import { useToast } from '../../../context/ToastContext';
import { useDeleteQuestionMutation } from '../../../services/endpoints/content/questions';
import { Document } from '../../../types/content.type';
import { getErrorMessage } from '../../utils';

const DeleteQuestionButton: React.FC<{ id: number }> = ({ id }) => {
  const [showModal, setShowModal] = useState(false);
  const [deleteQuestion, { isLoading }] = useDeleteQuestionMutation();
  const { addToast } = useToast();

  const handleDelete = async () => {
    try {
      await deleteQuestion(id).unwrap();
      addToast('Question deleted successfully', 'success');
      setShowModal(false);
    } catch (e) {
      addToast(getErrorMessage(e), 'error');
    }
  };

  return (
    <>
      <button
        className="text-info fw-bolder btn btn-link p-0"
        style={{ fontSize: '.875rem', textDecoration: 'underline' }}
        onClick={() => setShowModal(true)}
      >
        Delete
      </button>
      <ConfirmationModal
        show={showModal}
        title="Delete Question"
        message="Are you sure you want to delete this question?"
        confirmText="Yes, Delete"
        cancelText="Cancel"
        onConfirm={handleDelete}
        onCancel={() => setShowModal(false)}
        isLoading={isLoading}
      />
    </>
  );
};

export const questionsColumns: ColumnDef<Document>[] = [
  {
    header: 'ID',
    accessorKey: 'id',
    cell: ({ getValue }) => (
      <LinkCell
        content={getValue<number>()}
        url={`/admin/content/questions/${getValue<number>()}`}
      />
    )
  },
  {
    header: 'Name',
    accessorKey: 'name'
  },
  {
    header: 'Question Type',
    accessorKey: 'question_type'
  },
  {
    header: () => null,
    id: 'actions',
    enableSorting: false,
    cell: ({ row }) => (
      <Stack
        direction="horizontal"
        gap={2}
      >
        <LinkCell
          content="View"
          url={`/admin/content/questions/${row.original.id}`}
          underline
        />
        <LinkCell
          content="Edit"
          url={`/admin/content/questions/${row.original.id}/edit`}
          underline
        />
        <DeleteQuestionButton id={row.original.id} />
      </Stack>
    )
  }
];
